import { compose, isNil, objOf, path, pluck, propOr, reject } from 'ramda';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import useSaveSouscriptionWaiverStagesMutation from './useSaveSouscriptionWaiverStagesMutation';
import { useProcess } from '@fasstech/oip-starter-utils/app';
import {
  formatExtraDataBeforeSubmit,
  formatExtraDefaultValues
} from '../extra/formatExtraData.mjs';

const useSouscriptionWaiverStagesForm = ({ getGrantees, getOffer }) => {
  const [loading, setLoading] = useState(false);
  const beneficiaires = propOr([], 'beneficiaries', getGrantees);

  const beneficiariesTypes = compose(reject(isNil), pluck('type'))(beneficiaires);

  const form = useForm({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    defaultValues: compose(
      formatExtraDefaultValues(beneficiaires),
      objOf('offer'),
      propOr({}, 'offer')
    )(getOffer)
  });

  const { processHandlers, context } = useProcess();

  const saveWaiverRequests = useSaveSouscriptionWaiverStagesMutation();

  const $onClickPrev = () => {
    processHandlers.onPrev({
      context: {
        projectId: context?.projectId
      }
    });
  };

  const onSubmit = (values) => {
    if (loading) return;
    setLoading(true);

    values = compose(objOf('packs'), formatExtraDataBeforeSubmit, path(['offer', 'packs']))(values);

    saveWaiverRequests.onFormSubmit(values, (ok, error) => {
      if (ok && !error) {
        processHandlers.onNext({
          context: {
            projectId: context?.projectId
          }
        });
      } else {
        setLoading(false);
      }
    });
  };

  return {
    form,
    onSubmit,
    $onClickPrev,
    beneficiariesTypes
  };
};

export default useSouscriptionWaiverStagesForm;
